import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { AnchorLoader } from '@/components/AnchorLoader'

// Gerbang auth SPA (pengganti middleware.ts V1):
//  - loading → tampilkan loader (belum tahu status sesi).
//  - belum login → /login.
//  - login tapi belum punya departemen & bukan di /onboarding → /onboarding.
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const pathname = useLocation().pathname

  if (loading) return <AnchorLoader />
  if (!user) return <Navigate to="/login" replace />

  if (!user.department && pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />
  }

  return <>{children}</>
}
